import React, { Suspense }  from 'react';
import queryString from 'query-string';
import { Switch, Router } from 'react-router';
import { Route } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import { I18nextProvider } from 'react-i18next';

import './App.css';
import { Nav } from './components/nav';
import history from './util/history';
import theme from './util/theme';
import { WebRoutes } from './apply-routes';
import ApplyPageContainer from './components/apply-page-container';
import { Footer } from './components/footer';
import { logGAEvent } from './util/log-ga';
import i18n from './i18n';

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <Suspense fallback="loading">
        <MuiThemeProvider theme={theme}>
          <Router
            history={history}
          >
            <div>
              <CssBaseline />
              <div style={{ minHeight: '80vh' }}>
                <Nav />
                <Switch>
                  <Route
                    path={WebRoutes.referralApplyRoute()}
                    render={(props: Object) => (
                      <ApplyPageContainer
                        jobHash={props.match.params.jobHash}
                        referralHash={props.match.params.referralHash}
                        source="referral"
                      />
                    )}
                  />
                  <Route
                    path={WebRoutes.jobApplicationRouteVersioned()}
                    render={(props) => {
                      const params = queryString.parse(props.location.search);
                      logGAEvent('Application', 'Apply');
                      let source = params.utm_source;
                      if (Array.isArray(source)) {
                        ([source] = source);
                      }
                      return (
                        <ApplyPageContainer
                          jobHash={props.match.params.jobHash}
                          source={source}
                          version={props.match.params.version}
                        />
                      );
                    }}
                  />
                  <Route
                    path={WebRoutes.jobApplicationRoute()}
                    render={(props) => {
                      const params = queryString.parse(props.location.search);
                      let source = params.utm_source;
                      if (Array.isArray(source)) {
                        ([source] = source);
                      }
                      return (
                        <ApplyPageContainer
                          jobHash={props.match.params.jobHash}
                          source={source}
                          sid={params.sid}
                        />
                      );
                    }}
                  />
                </Switch>
                <Footer />
              </div>
            </div>
          </Router>
        </MuiThemeProvider>
      </Suspense>
    </I18nextProvider>
  );
}

export default App;
